"use client";

import Link, { LinkProps } from "next/link";
import posthog from "posthog-js";
import React from "react";

type TrackedLinkProps = LinkProps & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> & {
  children: React.ReactNode;
  eventName: string;
  eventProperties?: Record<string, unknown>;
};

export default function TrackedLink({
  eventName,
  eventProperties,
  children,
  ...props
}: TrackedLinkProps) {
  return (
    <Link
      {...props}
      onClick={(e) => {
        posthog.capture(eventName, eventProperties);
        if (props.onClick) {
          props.onClick(e);
        }
      }}
    >
      {children}
    </Link>
  );
}
